<template>
<div class="panel">
    <div class="row columns">
        <div class="panel-title big-title">
            Rapport de dungeon Bowl
        </div>
        <wizard :step="1" :isDB="true"></wizard>
        <hr>
        <div class="panel-content" v-if="current">
                    <div class="row columns">
                        <div class="large-5 large-centered columns ">
                            <div class="text-centered">Date de la rencontre</div>
                            <datepicker v-model="match_date" language="fr"></datepicker>
                        </div>
                    </div>
                    <br>
                    <div class="row columns">
                        <div class="large-2 columns large-centered">
                            <button  @click="validate" class="full-width">Suivant</button>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <spinner></spinner>
                </div>
            </div>
        </div>
</template>

<script>
import spinner from '../common/spinner.vue'
import wizard from '../common/wizard.vue'
import { mapGetters } from 'vuex'
import store from '../../store/index.js'
import matchReport from '../../api/match-report.api'
import Datepicker from 'vuejs-datepicker'
import createWeekModal from '../common/create-week-modal.vue'
import messageModal from '../common/message-modal.vue'

export default {
  name: 'mrDBStep2',
  components: {
    spinner,
    wizard,
    Datepicker,
    createWeekModal,
    messageModal
  },
  props: {
    'id': String
  },
  data () {
    return {
      'weather': 2,
      'match_date': null,
      'match_week': null,
      'fans': 0,
      'fame': 0,
      'inducement': 0,
      'treasury_for_inducement': 0,
      'error_msg': null,
      'isInit': false,
      'errorsList': []
    }
  },
  computed:
  {
    ...mapGetters([
      'currentUser',
      'matchReportList',
      'teamReportList'
    ]),
    ...mapGetters({
      current: 'detailedMatchReport'
    })
  },
  methods: {
    initDatas () {
      this.match_date = this.current.date
      this.isInit = true
    },
    checkValid () {
      if (this.match_date === null) {
        return false
      }
      return true
    },
    isErrors () {
      if (this.match_week) {
        let foundHomeReport = this.matchReportListmatchReportList.find(mr => {
          return (mr.team_reports[0].team.id === this.home.id || mr.team_reports[1].team.id === this.home.id) && mr.week === this.match_week.id
        })
        console.log(foundHomeReport)
        if (foundHomeReport) {
          this.errorsList.push('L\'équipe ' + this.home.name + ' a déjà un rapport de match sur la journée ' + this.match_week.title + ', les équipes ne peuvent pas jouer deux fois sur une même journée.')
        }

        let foundVisitorReport = this.matchReportListmatchReportList.find(mr => {
          return (mr.team_reports[0].team.id === this.visitors.id || mr.team_reports[1].team.id === this.visitors.id) && mr.week === this.match_week.id
        })
        if (foundVisitorReport) {
          this.errorsList.push('L\'équipe ' + this.visitors.name + ' a déjà un rapport de match sur la journée ' + this.match_week.title + ', les équipes ne peuvent pas jouer deux fois sur une même journée.')
        }
        return 1
      }
    },
    goToNext () {
      this.$router.push({
        name: 'mrStep3',
        params: {
          id: this.teamReportList[0].id,
          teamid: this.teamReportList[0].team.id,
          matchId: this.current.id
        }
      })
      this.$store.dispatch('invalidateDetailedMatchReport')
    },
    validate () {
      if (this.checkValid() === false) {
        this.error_msg = "certaines données n'ont pas été remplies ou sont incorrectes, vérifiez que tout est bien présent"
        return
      }
      // update match report datas
      let mr = {}
      mr.id = this.current.id
      mr.date = this.match_date
      mr.week = this.match_week
      mr.is_db_report = true
      matchReport.api.updateMatchReport(mr).then(
        response => {
          this.goToNext()
        },
        error => {
          this.errorsList.push(error.body.detail)
        }
      )
    }
  },
  watch: {
    current: function (newMr, oldState) {
      if (oldState === null) {
        this.initDatas()
      }
    }
  },
  mounted () {
    this.$store.dispatch('invalidateDetailedMatchReport')
    this.$store.dispatch('getDetailedMatchReport', this.id.toString())
    this.$store.dispatch('getTeamReportListForMatch', this.id.toString())
  },
  created () {
    store.dispatch('hideLeaguePanel')
    store.dispatch('deactivateFullSizePage')
    store.dispatch('getMatchReportList')
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.big-title {
    font-size: 1.6rem;
}
.match-team-name {
    font-size: 1.3rem;
}

.day-select {
    padding-left: 0;
}
.day-button {
    padding: 0.8rem;
}
</style>



// WEBPACK FOOTER //
// mr-db-step-2.vue?129c6f75